import { gql } from 'graphql-tag';

export default gql`
  extend type Task {
    path: [String]
  }
`;
